var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPixLogoBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.887,
    viewBox: "0 0 16 15.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5758",
    "data-name": "Group 5758",
    transform: "translate(308.136 -934.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2376",
    fill: "#AA7339",
    d: "M406.124,433.624l1.8,1.8a3.192,3.192,0,0,0,.558.447l-1.582,1.582a1.236,1.236,0,0,1-1.748,0l-1.509-1.509a3.192,3.192,0,0,0,.663-.51l1.814-1.814m0-1.291a.426.426,0,0,0-.295.118l-2.253,2.253a2.185,2.185,0,0,1-1.548.644h-.071a.156.156,0,0,0-.111.267l2.576,2.576a2.274,2.274,0,0,0,3.215,0l2.851-2.851h-.276a2.185,2.185,0,0,1-1.549-.644l-2.244-2.245a.426.426,0,0,0-.295-.118Zm4.364,3.007h0Z",
    transform: "translate(-706.146 511.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2380",
    fill: "#AA7339",
    d: "M406.325,352.158a1.227,1.227,0,0,1,.874.362l1.582,1.582a3.186,3.186,0,0,0-.556.445l-1.806,1.806-1.812-1.812a3.2,3.2,0,0,0-.665-.512l1.507-1.507,0,0a1.227,1.227,0,0,1,.874-.362m0-1.038a2.266,2.266,0,0,0-1.607.666h0l-2.53,2.529a.183.183,0,0,0,.13.313h.006a2.185,2.185,0,0,1,1.549.644l2.253,2.253a.417.417,0,0,0,.59,0l2.245-2.245a2.184,2.184,0,0,1,1.549-.644h.276l-2.851-2.851a2.266,2.266,0,0,0-1.607-.666Z",
    transform: "translate(-706.441 583.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8133",
    "data-name": "Path 8133",
    fill: "#AA7339",
    d: "M371.949,394.6a.546.546,0,0,1-.4-.184c-.021-.014-1.788-1.662-1.788-1.662l-.013-.012a2.792,2.792,0,0,1,0-3.949s1.782-1.661,1.8-1.676a.538.538,0,0,1,.417-.183h.954a2.055,2.055,0,0,1,1.453.6l2.254,2.254a.561.561,0,0,0,.79,0l2.244-2.244a2.056,2.056,0,0,1,1.453-.6h.785a.57.57,0,0,1,.4.171.52.52,0,0,1,.076.059l1.714,1.6.022.021a2.8,2.8,0,0,1,0,3.948l-.013.013-1.723,1.607a.52.52,0,0,1-.078.06.557.557,0,0,1-.4.17h-.784a2.055,2.055,0,0,1-1.453-.6l-2.24-2.24a.584.584,0,0,0-.8,0L374.376,394a2.055,2.055,0,0,1-1.453.6h-.974Zm-.026-1.258a.831.831,0,0,0,.564.22h.435a1.022,1.022,0,0,0,.722-.3l2.252-2.252.009-.008a1.629,1.629,0,0,1,.31-.233,1.592,1.592,0,0,1-.318-.246l-2.253-2.253a1.022,1.022,0,0,0-.722-.3h-.514a.653.653,0,0,0-.445.175l-1.487,1.385a1.755,1.755,0,0,0,0,2.469S371.457,392.915,371.923,393.345Zm5.911-2.572a1.626,1.626,0,0,1,.31.233l.009.008,2.244,2.244a1.021,1.021,0,0,0,.722.3h.072a1.335,1.335,0,0,0,.91-.357L383.385,392a1.757,1.757,0,0,0,0-2.467l-1.289-1.2a1.335,1.335,0,0,0-.909-.357h-.072a1.023,1.023,0,0,0-.722.3l-2.243,2.243A1.589,1.589,0,0,1,377.834,390.773Z",
    transform: "translate(-677.065 551.67)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixLogoBrown);
export default __webpack_public_path__ + "static/media/PixLogoBrown.205ae1811451b8fedb14a3945bb88a0b.svg";
export { ForwardRef as ReactComponent };